import type { CSSProperties } from 'react';

/** Layout style when running standalone (full viewport). */
export const staffLayoutStyle: CSSProperties = {
  backgroundColor: '#ECEFF2',
  height: '100vh',
  minHeight: '100vh',
  padding: '16px 24px 0',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

/** Layout style when embedded in Succeed: fill the allocated container, not the full viewport. */
export const staffLayoutStyleEmbedded: CSSProperties = {
  ...staffLayoutStyle,
  height: '100%',
  minHeight: 'unset',
};

/** Main content area: takes remaining space; flex container so child can fill height */
export const staffMainStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

/** Wrapper around route content: fills main */
export const staffMainContentStyle: CSSProperties = {
  flex: 1,
  minHeight: 0,
  overflowX: 'hidden',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

/** Slot rendered outside <main> so the action bar spans the full layout width with no side padding */
export const staffActionBarSlotStyle: CSSProperties = {
  flexShrink: 0,
  /* Breathing room: staff-layout grey (#ECEFF2) shows between main and footer */
  marginTop: '0.75rem',
  /* Pull back the parent's 24px side padding so we span edge-to-edge */
  marginLeft: '-24px',
  marginRight: '-24px',
};
